import React from "react";
import Logo from "../../Assets/Logo/logo-gif.gif";

const TitleCopy = {
  login: {
    title: "Login",
    subTitle: "Securely access your world with ease - Login now!",
  },
  register: {
    title: "Create Account",
    subTitle:
      "Join us today and create your account - Where possibilities are limitless!",
  },
  "verify-email": {
    title: "Verify Account",
    subTitle: "",
  },
  "forgot-password": {
    title: "Forgot Password",
    subTitle:
      "Enter your registerd email and we'll send you a link to reset your password",
  },
  "set-password": {
    title: "Reset Password",
    subTitle: "Enter your verification code and set new password",
  },
};

function AuthContainer(props) {
  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen bg-primary-varients-50">
        <div className="w-full max-w-md p-5 sm:p-14 md:p-14 lg:md-14 space-y-3 bg-white shadow-xl rounded-3xl">
          <div className="flex justify-center items-center mb-5">
            <img src={Logo} alt="logo" className="h-8 w-8" />
            <div className="ps-2 text-xl font-bold">InProfile</div>
          </div>
          <div className="space-y-1">
            <h2 className="text-2xl font-bold text-center">
              {TitleCopy[props?.type]?.title}
            </h2>
            <p className="text-slate-500 text-sm text-center">
              {TitleCopy[props?.type]?.subTitle}
            </p>
          </div>
          {props?.children}
        </div>
      </div>
    </>
  );
}

export default AuthContainer;
